import { gql } from '@apollo/client';

export const DELETE_FUNDER = gql`
  mutation deleteFunder($id: ID!) {
    deleteFunder(id: $id) {
      id
    }
  }
`;
